var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/parts/loadshopitemtemplate',["require", "exports", "common/parts", "areas/shopitemtemplate/services/mappings", "areas/shopitemtemplate/services/shopitemtemplaterepository"], function (require, exports, Parts, Mapping, Repository) {
    "use strict";
    var LoadShopItemTemplate = (function (_super) {
        __extends(LoadShopItemTemplate, _super);
        function LoadShopItemTemplate() {
            _super.apply(this, arguments);
        }
        LoadShopItemTemplate.prototype.process = function (memberType, symbol) {
            var _this = this;
            if (symbol == null) {
                this.output.call(null);
                return;
            }
            var repository = new Repository.ShopItemTemplateRepository();
            repository.read(memberType, symbol)
                .then(function (data) {
                var item = Mapping.mapShopItemTemplateFromDTO(data);
                _this.output.call(item);
            }).fail(function (error) {
                _this.error.call(error);
            });
        };
        return LoadShopItemTemplate;
    }(Parts.Part));
    return LoadShopItemTemplate;
});

